import api from '../utils/api';            // ← ADD THIS IMPORT
import config from '../config';

const patientService = {
  lookup: async (patientId) => {
    try {
      const url = `${config.PATIENT_SERVICE_URL}/api/patients/lookup/${encodeURIComponent(String(patientId).trim())}`;
      const res = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await res.json();
      return { status: res.status, ...data };
    } catch (err) {
      console.warn('[patientService] Service unavailable:', err.message);
      return {
        status: 503,
        found: false,
        message: 'Patient service is unavailable.',
        serviceDown: true,
      };
    }
  },

  search: async (query) => {
    try {
      const url = `${config.PATIENT_SERVICE_URL}/api/patients/search?q=${encodeURIComponent(query)}`;
      const res = await fetch(url);
      return res.json();
    } catch {
      return { count: 0, patients: [] };
    }
  },

  debug: async () => {
    try {
      const url = `${config.PATIENT_SERVICE_URL}/api/patients/debug`;
      const res = await fetch(url);
      return res.json();
    } catch (err) {
      return { error: err.message };
    }
  },

  // ── Update Scan — uses api utility so auth token is attached automatically ──
  updateCaseScan: async (caseId, formData) => {
    try {
      // ✅ Use api (axios) instead of raw fetch
      // The api interceptor already attaches the Authorization header
      const response = await api.put(
        `/cases/${caseId}/update-scan/`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      return response.data;
    } catch (error) {
      const msg =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.response?.data?.detail ||
        error.message ||
        'Failed to update scan.';
      throw new Error(msg);
    }
  },
};

export default patientService;